import React from 'react';
import { Alert } from 'react-bootstrap';

const PageNotFound = () => {
  return (
    <div>
      <Alert variant="danger">The page does not exist.</Alert>
    </div>
  );
};

export default PageNotFound;
